// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-view .card-component__content>.row-component[data-v-1b3ae556]{margin-bottom:20px}.popup-view .card-component__content>.row-component[data-v-1b3ae556]:last-of-type{margin-bottom:0}.popup-view .prism-component[data-v-1b3ae556]{margin-top:25px}", ""]);
// Exports
module.exports = exports;
